// extracted by mini-css-extract-plugin
export default {"imprintContainer":"y9XO7COC","imprintText":"iCQxjXm0","title":"WRAxPqCX","imprintTitle":"s4BZ_e9c","termCond":"sjyT0KWE"};